// @ts-strict-ignore
import { Tag } from "@aviary";
import type { PatientFilter } from "@shared/types/PatientSearch";

import type { Filter } from "../../CatalogSearch";

import * as styles from "./ActiveTags.styles";

interface Props {
  tags: Filter[] | PatientFilter[];
  handleOnRemove: (tag: Filter) => void;
}

const ActiveTags = ({ tags, handleOnRemove }: Props) => {
  return (
    <div>
      {tags.map(tag => (
        <Tag
          css={styles.tag}
          key={`${tag.id}-${tag.name}`}
          text={tag.name}
          handleClick={() => handleOnRemove?.(tag)}
        />
      ))}
    </div>
  );
};

export { ActiveTags };
